import * as yup from 'yup';
import { userTestDepositFormFields } from '../../fields/formFields/userTestDeposit';
import { amountSchema } from '../common/amountSchema';

export const userTestDepositSchema = yup.object({
  [userTestDepositFormFields.amount]: amountSchema,
  [userTestDepositFormFields.processNow]: yup.boolean(),
});
